<template>
  <div class="text-center w-100">
    <div class="bouncer">
      <div/>
      <div/>
      <div/>
      <div/>
    </div>
  </div>
</template>

<script>

export default {
  name: "Bouncer",
};

</script>

<style scoped>

.bouncer {
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  width: 5rem;
  height: 6rem;
}

.bouncer div {
  width: 1rem;
  height: 1rem;
  background: #0077FF;
  border-radius: 50%;
  animation: bouncer 0.5s cubic-bezier(.19, .57, .3, .98) infinite alternate;
}

.bouncer div:nth-child(2) {
  animation-delay: 0.1s;
  opacity: 0.8;
}

.bouncer div:nth-child(3) {
  animation-delay: 0.2s;
  opacity: 0.6;
}

.bouncer div:nth-child(4) {
  animation-delay: 0.3s;
  opacity: 0.4;
}

@keyframes bouncer {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-5rem);
  }
}

</style>